import { NOTIFICATIONS } from "@const/notifications";

import { useCustomerStore } from "@store/customer";
import { useLayoutStore } from "@store/layout";

export default function useSessionExpired() {
  const { logout } = useCustomerStore();
  const { openToast, openAccount } = useLayoutStore();

  return () => {
    openToast(NOTIFICATIONS.WARNING_END_SESSION);
    logout();
    setTimeout(() => {
      openAccount(true);
    }, 300);
  };
}
